// @flow
import CardSwapDashboard from './CardSwapDashboard.container';

export default CardSwapDashboard;
